<template>
  <div class="mb-4" v-if="is_not_open">
    <div v-if="mainStore.module.status == 'avant_ouverture'">
      <CountdownLaunch v-if="mainStore.module.status == 'avant_ouverture'"
        :date="mainStore.module.date_debut_inscription" :heure="mainStore.module.heure_debut_inscription"
        @onReload="onReload">
      </CountdownLaunch>
    </div>
    <div v-if="mainStore.module.status == 'apres_fermeture'">
      <div class="text-h6 font-weight-bold">
        <v-icon icon="mdi-calendar-clock" color="primary" size="xs-small"></v-icon> Fermé depuis le {{
          $moment(mainStore.module.date_fin_inscription).format("DD/MM/YYYY") }} à {{
          mainStore.module.heure_fin_inscription }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import CountdownLaunch from "@/components/Home/Countdown_Launch.vue";
export default {
  components: { CountdownLaunch },
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
    is_not_open() {
      return this.mainStore.module.status == 'avant_ouverture' || this.mainStore.module.status == 'apres_fermeture';
    }
  },
  methods: {
    onReload() {
      this.$forceUpdate();
    }
  },
  mounted() { },
};
</script>

<style lang="scss" scoped></style>